export const ERR_METHOD_UNSUPPORTED = 'ERR_METHOD_UNSUPPORTED';
export const ERR_RETRIEVE_LP_FAILED = 'ERR_RETRIEVE_LP_FAILED';
export const ERR_METHOD_PARAMETER_UNSUPPORTED = 'ERR_METHOD_PARAMETER_UNSUPPORTED';
export const ERR_UNKNOWN_ENV = 'ERR_UNKNOWN_ENV';
export const ERR_CUSTOM_METHOD_ERR_RESPONSE = 'ERR_INVOKE_CUSTOM_METHOD_RESPONSE';
